/**
 * AI编辑器专用样式常量
 */
// AI样式标签ID
export const AI_STYLE_ID = 'wuji-ai-blue-styles';
// AI编辑器专用CSS变量
export const AI_CSS_VARIABLES = `
  :root, :root[theme-mode="light"], :root[theme-color="default"] {
    --td-brand-color-1: #eff3ff;
    --td-brand-color-2: #d3e3ff;
    --td-brand-color-3: #b8caeb;
    --td-brand-color-4: #9caece;
    --td-brand-color-5: #8193b2;
    --td-brand-color-6: #667896;
    --td-brand-color-7: #4d5f7b;
    --td-brand-color-8: #364762;
    --td-brand-color-9: #1e304a;
    --td-brand-color-10: #0c2039;
  }
`;
// 错误消息常量
export const AI_STYLE_ERRORS = {
    REMOVE_FAILED: 'Failed to remove AI styles:',
};
// 样式管理工具函数
export class AIStyleManager {
    static instance;
    static getInstance() {
        if (!AIStyleManager.instance) {
            AIStyleManager.instance = new AIStyleManager();
        }
        return AIStyleManager.instance;
    }
    styleElement = null;
    /**
     * 创建并注入AI样式
     */
    createAIStyles() {
        // 检查是否已经存在AI样式，避免重复创建
        const existingStyle = document.getElementById(AI_STYLE_ID);
        if (existingStyle) {
            return;
        }
        // 创建AI编辑器专用样式
        this.styleElement = document.createElement('style');
        this.styleElement.id = AI_STYLE_ID;
        this.styleElement.textContent = AI_CSS_VARIABLES;
        document.head.appendChild(this.styleElement);
    }
    /**
     * 移除AI样式
     */
    removeAIStyles() {
        if (this.styleElement) {
            try {
                if (document.head.contains(this.styleElement)) {
                    document.head.removeChild(this.styleElement);
                }
            }
            catch (error) {
                console.warn(AI_STYLE_ERRORS.REMOVE_FAILED, error);
            }
            this.styleElement = null;
        }
    }
    /**
     * 检查AI样式是否存在
     */
    hasAIStyles() {
        return document.getElementById(AI_STYLE_ID) !== null;
    }
}
